import React from 'react';
import { I18n } from '@aws-amplify/core';
import * as S from '@/components/Settings/DataExtraction/styles';
import * as FormStyles from './styles';

export function FinalDateFormItem() {
	return (
		<S.CustomFormItem
			label={I18n.get('End reference date')}
			name={['general_information', 'final_date']}
			labelCol={{ span: 24 }}
		>
			<FormStyles.CustomDatePicker
				format="L"
				placeholder={I18n.get('Date')}
				disabledDate={(current) => current && current.valueOf() > Date.now()}
			/>
		</S.CustomFormItem>
	);
}
